'use client';

import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const EFFECTIVE_DATE = 'May 7, 2026';

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900">
      <Navigation />

      <section className="pt-32 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Cookie{' '}
            <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Policy
            </span>
          </h1>
          <p className="text-gray-400">Effective {EFFECTIVE_DATE}</p>
        </div>
      </section>

      <section className="pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-gray-800/40 border border-gray-700 rounded-xl p-8 md:p-12 space-y-10 text-gray-300 leading-relaxed">

          <div>
            <p>
              This Cookie Policy explains how Reclipt ("we", "us") uses
              cookies and similar technologies on the Reclipt website and
              dashboard (the "Service"). It should be read together with our{' '}
              <a href="/privacy" className="text-blue-400 hover:text-blue-300 underline">
                Privacy Policy
              </a>
              .
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">1. What cookies are</h2>
            <p>
              Cookies are small text files stored on your device when you
              visit a website. We also use related technologies such as
              localStorage and sessionStorage. We refer to all of these
              collectively as "cookies" in this policy.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">2. Cookies we use</h2>

            <h3 className="text-lg font-semibold text-white mt-6 mb-2">Strictly necessary</h3>
            <p>
              Required for the Service to function. These include
              authentication cookies set by our sign-in provider (Clerk) to
              keep you signed in, and session cookies that secure requests
              to our backend. The Service will not work without them.
            </p>

            <h3 className="text-lg font-semibold text-white mt-6 mb-2">Preferences</h3>
            <p>
              Remember choices you make in the dashboard such as theme,
              recently used folders, and dashboard layout. These are stored
              locally in your browser.
            </p>

            <h3 className="text-lg font-semibold text-white mt-6 mb-2">Analytics</h3>
            <p>
              Help us understand how the Service is used so we can improve
              it. These cookies record aggregated information such as pages
              viewed, features used, and basic device data. We do not use
              them to build advertising profiles.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">3. Third-party cookies</h2>
            <p>
              Some cookies are set by third-party services we use to operate
              Reclipt, including:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li><strong>Clerk</strong> — authentication and session management</li>
              <li><strong>Google</strong> — only when you choose to sign in with Google or import a file from Google Drive</li>
            </ul>
            <p className="mt-4">
              These third parties set their cookies according to their own
              policies, which we do not control.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">4. Managing cookies</h2>
            <p>
              You can control or delete cookies through your browser
              settings. Blocking strictly necessary cookies will prevent you
              from signing in or using core parts of the Service. You can
              also revoke Reclipt's access to your Google account at any
              time at{' '}
              <a
                href="https://myaccount.google.com/permissions"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 underline"
              >
                myaccount.google.com/permissions
              </a>
              .
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">5. Changes to this policy</h2>
            <p>
              We may update this Cookie Policy from time to time. Material
              changes will be announced through the Service. Continued use
              after a change becomes effective constitutes acceptance of the
              updated policy.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">6. Contact</h2>
            <p>
              Questions can be sent to{' '}
              <a href="mailto:support@reclipt.io" className="text-blue-400 hover:text-blue-300 underline">
                support@reclipt.io
              </a>
              .
            </p>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}
